import { styled } from '@mui/material/styles';
import { SvgLogoWithoutFullstop } from '@noah-labs/fe-shared-ui-assets/images/LogoWithoutFullstop';

export const AppLogoWithoutFullStop = styled(SvgLogoWithoutFullstop)(({ theme }) => ({
  color: theme.palette.brand.light,
  display: 'block',
  height: '19px',
}));
